import { ApiResponse, PropertyType } from '../utils/interfaces/user.interface'
import { AbortController } from '../utils/useSentryQuery'
import { axiosInstance } from './api'
import { authQueryFn } from './auth'
export async function getCpUsers({
    signal,
}: {
    signal: AbortController
}): Promise<ApiResponse> {
    return axiosInstance
        .get(`/getCpUsers`, { signal })
        .then((resp) => {
            return resp.data
        })
        .catch((error) => {
            console.error('Error fetching users:', error)
            throw error
        })
}

export async function getProperties({
    params,
    signal,
}: {
    params: { includeinactive: boolean; company?: number }
    signal: AbortController
}): Promise<PropertyType[]> {
    return axiosInstance
        .get(`/api/portalcustomers`, { params, signal })
        .then((resp) => {
            return resp?.data
        })
        .catch((error) => {
            console.error('Error fetching properties:', error)
            throw error
        })
}

export async function getSHCodeByProp({
    params,
    signal,
}: {
    params: {
        company: string
        customer: string
    }
    signal: AbortController
}) {
    return axiosInstance
        .get(`/api/getuserproperties`, { params, signal })
        .then((resp) => {
            return resp?.data as {
                CUST: string
                SHCODE: string
                PROPMGR: string
            }[]
        })
        .catch((error) => {
            console.error('Error fetching user properties:', error)
            throw error
        })
}

export async function getSHCodesByProps(customers: string[]): Promise<string> {
    const { userDetails } = authQueryFn()

    const promiseResult = await Promise.all(
        customers.map((customer) => {
            return new Promise((resolve) => {
                getSHCodeByProp({
                    company: userDetails.Company,
                    customer,
                }).then((data) => resolve({ data, key: customer }))
            })
        })
    )

    return promiseResult.reduce((prevVal, currentVal) => {
        if (!currentVal.data) return prevVal
        prevVal += `${currentVal.key},${currentVal.data.SHCODE}/*\\`
        return prevVal
    }, '')
}
